export const VISIT_CREATE_REQUEST = "VISIT_CREATE_REQUEST";
export const VISIT_CREATE_SUCCESS = "VISIT_CREATE_SUCCESS";
export const VISIT_CREATE_FAIL = "VISIT_CREATE_FAIL";
export const VISIT_CREATE_RESET = "VISIT_CREATE_RESET";

export const LIST_PATIENT_VISITS_REQUEST = "LIST_PATIENT_VISITS_REQUEST";
export const LIST_PATIENT_VISITS_SUCCESS = "LIST_PATIENT_VISITS_SUCCESS";
export const LIST_PATIENT_VISITS_FAIL = "LIST_PATIENT_VISITS_FAIL";
export const LIST_PATIENT_VISITS_RESET = "LIST_PATIENT_VISITS_RESET";

export const LIST_CLINIC_VISITS_REQUEST = "LIST_CLINIC_VISITS_REQUEST";
export const LIST_CLINIC_VISITS_SUCCESS = "LIST_CLINIC_VISITS_SUCCESS";
export const LIST_CLINIC_VISITS_FAIL = "LIST_CLINIC_VISITS_FAIL";
export const LIST_CLINIC_VISITS_RESET = "LIST_CLINIC_VISITS_RESET";

export const VISIT_SCAN_UPDATE_REQUEST = "VISIT_SCAN_UPDATE_REQUEST";
export const VISIT_SCAN_UPDATE_SUCCESS = "VISIT_SCAN_UPDATE_SUCCESS";
export const VISIT_SCAN_UPDATE_FAIL = "VISIT_SCAN_UPDATE_FAIL";
export const VISIT_SCAN_UPDATE_RESET = "VISIT_SCAN_UPDATE_RESET";
